/**
 * Tarifs ABFT utilisés par les modèles de facture.
 *
 * Un seul endroit à tenir à jour. Les tarifs d'examen reprennent ceux déjà
 * pratiqués par l'écran des inscriptions (InscriptionsResultats.vue, pricesDPK) ;
 * les autres restent à confirmer par le secrétariat et valent 0 d'ici là, pour
 * qu'aucun montant ne soit inventé sur une facture.
 */

export const TARIFS = {
  // Connus : repris de l'écran des inscriptions aux formations
  examenDan: 50,
  examenDanRepassage: 50,
  examenKeup: 15,

  // À confirmer : renseigner ici suffit à les faire apparaître sur les modèles
  cotisationAnnuelle: null,
  formationAdeps: null,
  fapArbitrageCombat: null,
  fapArbitrageTechnique: null,
  fapCarteCoach: null,
  diplomeKukkiwon: null
}

/**
 * Montant d'un tarif, ou 0 s'il n'est pas encore fixé : une ligne à 0 € se
 * complète à la main, un montant inventé passerait inaperçu.
 */
export function tarif (cle) {
  const valeur = TARIFS[cle]
  return typeof valeur === 'number' && isFinite(valeur) ? valeur : 0
}

export default {TARIFS, tarif}



// WEBPACK FOOTER //
// ./src/utils/facture/tarifs.js